// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "13b9a9cf03a7e55c3f53" + ".chunk.js";
};